/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, { useContext, useEffect, useRef, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Field, FieldArray, Form, Formik } from 'formik';
import ButtonUpload from 'components/ButtonUpload'

import Colors from 'constants/Colors';
import { GlobalAuthContext, GlobalLoaderContext } from 'store/context';
import DialogAlertMessage from 'components/DialogAlertMessage';
import { Text } from 'components/Text';

import { Layout, DateRangePicker } from 'components';
import { Col, Row } from 'components/Grid';
import Icon from 'components/Icon';
import Loader from 'components/Loader';
import { GridColumnTitle, InputField, Label, SelectField, } from 'components/Form';
import DialogComponent from "components/Dialog";
import { FitinsurAPI, MessageCenter } from 'utils';
import {
  ColGrid,
  RowGrid,
  FieldGrid,
  ColIcon,
  TableHeader,
  TableCollum,
  CalendarContainer,
  Content,
  ContentTextarea,
  CustomField,
  DialogCancel,
  DialogConfirm,
  IconContainer,
  InlineLabel,
  LoadContainer,
  MobileContainer,
  MobileFilterOrder,
  MobileLabel,
  RowFilterOrder,
  RowFilterSearch,
  DialogIcon,
  TableHead,
  TableRow,
  TableBody,
  Table,
  ButtonContainerRow,
  ButtonContent
} from './styles';
import { Button } from 'components/index';


export default function PaymentPage() {
  const loading = useContext(GlobalLoaderContext);
  const authContext = useContext(GlobalAuthContext);
  const fitinsur = new FitinsurAPI();
  const mc = new MessageCenter();
  const [deals, setDeals] = useState([]);
  const [documentId, setDocumentId] = useState("");
  const [dialogOpen, setDialogOpen] = useState({ open: false });

  function renderOSndModal() {
    return (
      <DialogAlertMessage icon={"exclamation"} title={"OSND - IMPORT"}  show={dialogOpen.open} setDialog={setDialogOpen}>
        <ContentTextarea>
          <Text>
            You are about to make changes to the transactions below:
          </Text>

          <div style={{ maxHeight: 250, overflow: 'auto', marginTop: 10 }}>
            {!deals.length ? <Text> No deals found</Text> : ''}
            {deals.map(v => <><Text> Deal: {v.rootOperationReferenceNumber ? `${v.rootOperationReferenceNumber}/${v.referenceNumber}` : v.referenceNumber} - OSND: {v.osnd}</Text><br /></>)}
          </div>
          <ButtonContainerRow>
            <ButtonContent><Button secundary onClick={() => setDialogOpen({ open: false })}>CANCEL</Button></ButtonContent>
            <ButtonContent><Button style={{ backgroundColor: Colors.BLUE, color: Colors.WHITE, marginLeft: 15 }} onClick={() => deals.length ? processFile() : setDialogOpen({ open: false })}>CONFIRM</Button></ButtonContent>
          </ButtonContainerRow>
        </ContentTextarea>
      </DialogAlertMessage>
    )
  }

  const processFile = async () => {
    loading.start();
    setDialogOpen({ open: false });
    fitinsur.setAuthToken(authContext.token);
    const response = await fitinsur.requestProcessReportFile(documentId).then(response => response.json());
    if (response.ret_code !== 200) mc.error(response.ret_msg_details);
    if (response.ret_code === 200) {
      localStorage.setItem('processing-file', documentId);
      mc.success('Please wait - your file is being processed!');
    }
    loading.stop();
  }

  return (
    <>
      <ButtonUpload multiple={false}
        documentTypeRequired={false}
        text={'IMPORT OSND'}
        hasOsndFlag={true}
        onSuccess={async ([file]) => {
          loading.start();
          try {
            fitinsur.setAuthToken(authContext.token);
            let response = await fitinsur.requestProcessReportFile(file.documentId, true).then(response => response.json());
            if (response.ret_code !== 200) {
              mc.error(response.ret_msg_details);
              return loading.stop();
            }
            
            if (response.ret_code === 200) {
              setDocumentId(file.documentId);
              localStorage.setItem('pre-processing-file', file.documentId);
            }

            const checkImport = async () => {
              const processingFileId = localStorage.getItem('pre-processing-file');
              if (!processingFileId) return;

              try {
                fitinsur.setAuthToken(authContext.token);
                let response = await fitinsur.requestProcessReportFileStatus(processingFileId).then(response => response.json());
                if (response.ret_code !== 200 || !response.ret_value.readyToProcess) return setTimeout(() => checkImport(), 2000);

                localStorage.removeItem('pre-processing-file');
                setDeals(response.ret_value.foundInstallments)
                setDialogOpen({ open: true })
                loading.stop()
              } catch (e) {
                localStorage.removeItem('pre-processing-file');
                mc.error('Sorry, there was an error uploading your file, please try again!');
                loading.stop();
              }
            };

            checkImport();
          } catch (e) {
            mc.error('Sorry, there was an error uploading your file, please try again!');
            loading.stop();
          }
        }}
      />
      {renderOSndModal()}
    </>
  );
}
